import { useEffect } from 'react';

/**
 * Scrolls `window` to the top when any dependency changes.
 * For SPAs that swap views via state (e.g. tabs) without a route change.
 *
 * Pass each dependency as its own argument (same semantics as useEffect deps).
 *
 * @param {...unknown} deps
 */
export const useScrollToTopOnChange = (...deps) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, deps);
};
